const handleEnter = (func) => (e) => {
  if (e) {
    if (e.keyCode === 13) {
      if (func) {
        func();
      }
    }
  }
};

const ModalInput = (props) => {
  let inputField;
  switch (props.type) {
    case "radio": {
      inputField = (
        <ModalInputRadio
          onChange={props.onChange}
          onBlur={props.onBlur}
          value={props.value}
          name={props.name}
        />
      );
      break;
    }
    case "file": {
      inputField = (
        <ModalInputFile
          onChange={props.onChange}
          onBlur={props.onBlur}
          value={props.value}
          name={props.name}
        />
      );
      break;
    }
    default: {
      inputField = (
        <ModalInputText
          onChange={props.onChange}
          onBlur={props.onBlur}
          onEnter={handleEnter(props.onEnter)}
          value={props.value}
          placeholder={props.placeholder}
          name={props.name}
          autoFocus={props.autoFocus}
        />
      );
      break;
    }
  }

  return (
    <ModalInputWrapper
      label={props.label}
      error={props.error}
      hint={props.hint}
    >
      {inputField}
    </ModalInputWrapper>
  );
};

export const ModalInputWrapper = (props) => {
  return (
    <div
      className="form-field no-padding"
      style={{ width: "100%", marginBottom: "7px" }}
    >
      {props.label && (
        <label style={{ marginLeft: "0px", marginBottom: "5px" }}>
          {props.label}
        </label>
      )}
      {props.children}
      {props.error && (
        <span
          className="error"
          style={{ display: "block", marginTop: "5px", color: "#a53817" }}
        >
          {props.error}
        </span>
      )}
      {props.hint && (
        <div className="help-text" style={{ marginTop: "5px" }}>
          {props.hint}
        </div>
      )}
    </div>
  );
};

export const ModalInputText = (props) => (
  <input
    type="text"
    style={{ width: "100%", marginLeft: "0px" }}
    className="string"
    onChange={props.onChange && ((e) => props.onChange(e))}
    onBlur={props.onBlur && ((e) => props.onBlur(e))}
    placeholder={props.placeholder || ""}
    value={props.value}
    name={name}
    readOnly={!props.onChange}
    onKeyDown={props.onEnter}
    autoFocus={props.autoFocus}
  />
);

export const ModalInputRadio = (props) => {
  return (
    <label className="radio">
      <input
        type="radio"
        onChange={props.onChange && ((e) => props.onChange(e))}
        onBlur={props.onBlur && ((e) => props.onBlur(e))}
        placeholder={props.placeholder || ""}
        value={props.value}
        name={name}
        readOnly={!props.onChange}
        checked={props.value === props.selectedValue}
      />
      {props.label}
    </label>
  );
};

export const ModalInputFile = (props) => {
  return (
    <a className="btn-primary btn button input-file-button">
      {t("phrases.react_content.choose_file")}
      <input
        type="file"
        onChange={props.onChange && ((e) => props.onChange(e))}
        name={name}
        readOnly={!props.onChange}
        checked={props.value === props.selectedValue}
      />
    </a>
  );
};

export default ModalInput;
